import React, { useEffect, useState } from "react";
import { AuthNavbar } from "../../components/auth/AuthNavbar";
import { BiArrowBack } from "react-icons/bi";
import freePricingIcon from "../../assets/freepricing_icon.png";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../components/button/CustomButton";
import { useParams } from "react-router-dom";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentPlanThunk as onGetPaymentPlans } from "../../slices/users/thunk";

export const PricingPlan = () => {

  const { role,userId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [plans, setPlans] = useState([]);
  const [isProfile, setIsProfile] = useState(false);
  const [currentPlanId, setCurrentPlanId] = useState(null);

  

  const selectPlansState = (state) => state.user;
  const plansSelector = createSelector(selectPlansState, (auth) => ({
    isLoading: auth.isLoading,
    paymentPlans: auth.paymentPlans,
  }));

  const {paymentPlans } = useSelector(plansSelector);

  //we need to check route to determine if we are in profile or pricing page
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes("/user/pricing")) {
      setIsProfile(true);
    }
  }, []);

  //we need to check from local storage its current plan of user and set it to state
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("authUser"));  

    if (userData && userData.user && userData.user.subscribe_plan) {
      setCurrentPlanId(userData.user.subscribe_plan.plan_id);
    } 
  }, []);

  useEffect(() => {
    dispatch(onGetPaymentPlans({'role':role})); 
  },[dispatch]);

  useEffect(() => {
    if (paymentPlans && paymentPlans.length > 0) {
      setPlans(paymentPlans);
    }
  }, [paymentPlans]);

  const handleNavigation = (planId) => {

    if(!isProfile){

      navigate(`/checkout/${userId}/${planId}/${role}`);
    }else{

      if(currentPlanId !== planId  && planId !== 1){
      navigate(`/user/checkout/${userId}/${planId}/${role}`);




    }


  };
}

  return (
    <div className="w-full min-h-screen bg-[#F7F7F7]">
      <AuthNavbar title="Pricing Plans" />
      <div className="pt-20 sm:pt-28  px-4 sm:px-10">
        <div className="w-[50px] h-[50px] bg-transparent rounded-[10px] border border-border_color flex items-center justify-center cursor-pointer">
          <button onClick={() => navigate(-1)}>
            <BiArrowBack className="text-4xl" />
          </button>
        </div>
      </div>

      <div className="w-full flex items-center justify-center sm:mt-10">
        <div className="w-full max-w-[922px] p-5">
          <div className="flex justify-center items-center bg-white rounded-[20px] shadow-md w-full p-3 sm:p-7 mb-10">
            <div className="w-full flex flex-col sm:flex-row justify-center items-center  gap-5">
              {plans?.map((plan) => (
                <div
                  key={plan.planId}
                  className="w-full max-w-[406px]  border border-border_color rounded-2xl p-3 sm:p-6 flex justify-between bg-white"
                >
                  <div className="w-full flex flex-col gap-7">
                    {/* Icon */}
                    <div className="p-3 w-[48px] h-[48px] bg-[#3749A6] flex items-center justify-center rounded-xl">
                      <img
                        src={freePricingIcon}
                        alt="Loading"
                        className="w-[30px] h-[30px] object-contain"
                      />
                    </div>

                    {/* Title */}
                    <h2 className="text-secondary text-[22px] font-bold font-grotesk">
                      {plan.title}
                    </h2>

                    {/* Price */}
                    <div className="flex items-end gap-2">
                      <span className="text-[40px] leading-none text-primary font-bold font-grotesk">
                        ${plan.price}
                      </span>
                      <span className="text-[16px] font-bold font-grotesk text-[#797878] mb-1">
                        per month
                      </span>
                    </div>

                    {/* Features */}
                    <div className="flex flex-col gap-2">
                      {plan.plannedServices?.map((service) => (
                        <p
                          key={service.id}
                          className="flex items-center text-black text-lg font-medium font-grotesk"
                        >
                          <span
                            className={`w-5 h-5 mr-2 flex items-center justify-center bg-white border rounded-full ${
                              service.enable === "1"
                                ? "border-primary text-primary"
                                : "border-[#F12F1F] text-[#F12F1F]"
                            }`}
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="w-3 h-3"
                              viewBox="0 0 24 24"
                            >
                              <path d="M20 6L9 17l-5-5" />
                            </svg>
                          </span>
                          {service.service}
                        </p>
                      ))}
                    </div>

                    {/* Button */}
                    <div className="w-full mt-8">
                      <CustomButton
                        className={`${
    currentPlanId === plan.planId
      ? "bg-gray-400 cursor-not-allowed opacity-70"
      : ""
  }`}
                        text={currentPlanId === plan.planId ? "Current Plan" : isProfile ? "Upgrade Plan" : "Get started"}
                        onClick={() => handleNavigation(plan.planId)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
